export const ContractManagementModuleName = 'kontrakter';

export enum ContractManagementTabs {
    avtaler = 'avtaler',
    levendekontrakter = 'forhandling',
    signering = 'signering',
}

export const LeaseAgreementModuleName = 'avtaler';
